export default {

  GET_PRODUCTS_REQUEST: 'GET_PRODUCTS_REQUEST',
  SET_PRODUCTS: 'SET_PRODUCTS',
}
